import { Box, Flex, TableContainer } from "@chakra-ui/react";
import { useResource } from "hooks/resources/providers/resourceProvider";
import { DataTableActions } from "./data-table-actions";
import { DataTablePagination } from "./data-table-pagination";
import { DataTableConfig } from "./types/data-table.config";

export function DataTableContainer<T>({
  table,
  modal,
  configuration,
}: {
  table: React.ReactNode;
  modal: React.ReactNode;
  configuration: DataTableConfig;
}) {
  const { modal: modalResource } = useResource<T>();

  return (
    <Flex flexDirection="column" gap={4}>
      <Box>
        <DataTableActions<T> {...configuration} />
      </Box>
      <Box>
        <Flex flexDirection="column" gap={4}>
          <TableContainer>{table}</TableContainer>
          <DataTablePagination<T> />
        </Flex>
      </Box>
      {modalResource.isOpen && modal}
    </Flex>
  );
}
